import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/medizinrecht.webp";

const data: AreaContent = {
  id: Area.MEDIZINRECHT,
  hero: hero,
  content: [
    "Wir beraten und vertreten Ärzt:innen bei der Verwirklichung ihres Niederlassungswunsches und unterstützen bei der Gestaltung vertragsärztlicher Kooperationsformen.",
    "Insbesondere beraten wir Sie bei:",
    [
      "der Gründung von Medizinischen Versorgungszentren (MVZ)",
      "der Gründung oder dem Beitritt zu einer Praxisgemeinschaft oder Berufsausübungsgemeinschaft",
      "Praxisübernahmen und Praxisnachfolgen",
      "Kooperationen mit anderen Leistungserbringer:innen",
    ],
    "Als Leistungserbringer:innen der gesetzlichen Krankenversicherung unterliegen Vertragsärzt:innen besonderen Regelungen. Wir stehen Ihnen hierbei beratend und gestaltend zur Seite, insbesondere bei Fragen zu:",
    [
      "der Zulassung als Vertragsärzt:in",
      "der Nachbesetzung eines Vertragsarztsitzes",
      "der Vorbereitung und Umsetzung einer Praxisaufgabe oder Nachfolgeregelung",
      "der Anstellung von Ärzt:innen",
      "der Nachbesetzung bestehender Arztstellen",
      "Plausibilitätsprüfungen",
      "Wirtschaftlichkeitsprüfungen",
      "der Abrechnung nach GOÄ und/oder EBM",
      "vertragsärztlichen Disziplinarverfahren",
      "der Prüfung und Abwehr von Arzthaftungsansprüchen",
    ],
    "Nichtärztliche Leistungserbringer:innen, zum Beispiel Sanitätshäuser, beraten wir bei der Gestaltung von Kooperationen mit anderen Leistungserbringer:innen der gesetzlichen Krankenversicherung. Dabei berücksichtigen wir die geltenden berufs- und sozialrechtlichen Regelungen, insbesondere §§ 299a, 299b StGB und § 128 SGB V.",
    "Darüber hinaus beraten wir zum Heilmittelwerberecht.",
    "Als Patient:innen beraten und unterstützen wir Sie unter anderem bei der Durchsetzung von Versorgungsansprüchen, zum Beispiel in den Bereichen:",
    [
      "Hilfsmittelversorgung, etwa bei der Prothesenversorgung",
      "Kostenerstattung bei der Inanspruchnahme neuer Untersuchungs- und Behandlungsmethoden, zum Beispiel Genexpressionsanalysen",
    ],
  ],
  bullets: [
    "Arzthaftungsrecht",
    "Kooperationen im Gesundheitswesen",
    "Vertragsarztrecht",
    "Berufsrecht",
    "Recht der Medizinischen Versorgungszentren (MVZ)",
  ],
  more: [
    {
      title: "Bundesministerium für Gesundheit",
      href: "https://www.bundesgesundheitsministerium.de/",
    },
    { title: "Bundesärztekammer", href: "https://www.bundesaerztekammer.de/" },
    {
      title: "Kassenärztliche Bundesvereinigung",
      href: "https://www.kbv.de/html/",
    },
    { title: "Bundeszahnärztekammer", href: "https://www.bzaek.de/" },
    {
      title: "Bundessozialgericht",
      href: "https://www.bsg.bund.de/cln_108/DE/Home/homepage__node.html?__nnn=true",
    },
  ],
};

export default data;
